// extracted by mini-css-extract-plugin
export default {"filter":"QuestionList_filter__4ZFVD","fadeIn":"QuestionList_fadeIn__NfGKs","tblheader":"QuestionList_tblheader__fgqpd","btn":"QuestionList_btn__BqJa9"};